// extracted by mini-css-extract-plugin
export default {"BtnLink":"ButtonLink_BtnLink__-Th6k"};